export default "__VITE_ASSET__6NjKybRj__"